import React, { Component } from 'react';
import { Fragment } from 'react';
import swal from 'sweetalert';

import NabVelocity from './nab/NabVelocity.js';
import jumperStore from '../../../stores/jumpers-store.js';
import Api from '../../../services/reservationapi.js';

class CardButton extends Component {
    
    constructor(props){
        super(props);
        this.state={
                transactionId: '',
        }
    }
    
    handleCard = () => {
        // document.getElementsByClassName('velocity-button')[0].click();
        if (window.ENV?.processorInfo.processor == "nab") {
            document.getElementsByClassName('velocity-button')[0].click();
        }
        else if (window.ENV?.processorInfo.processor == "cardConnect") {
            window.initializeCardConnect("adding_card");
            var modal = document.getElementById("myModalCardConnect");
            modal.style.display = "block";
            window.addCardComponent = this;
        }
        else if (window.ENV?.processorInfo.processor == "transnational") {
            // used in /public/index.html
            window.addCardComponent = this;
            window.transactionUI("adding_card");
            var modal = document.getElementById("myModal");

            // Get the button that opens the modal
            var btn = document.getElementById("myBtn");

            // Get the <span> element that closes the modal
            var span = document.getElementsByClassName("close")[0];

            // When the user clicks the button, open the modal 
            // btn.onclick = function () {˚
            modal.style.display = "block";
            // }

            // When the user clicks on <span> (x), close the modal
            span.onclick = function () {
                modal.style.display = "none";
            }
            window.reservationComponent = this;

            // When the user clicks anywhere outside of the modal, close it
            window.onclick = function (event) {
                if (event.target == modal) {
                    modal.style.display = "none";
                }
            }
        }
    }
    handleCardResponse = (r) => {
    console.log("🚀 ~ file: CardButton.js ~ line 59 ~ CardButton ~ r", r)
        var id = this.props.jumperId;
        const { transactionId } = this.state;

        if (r.Status === "Successful" && transactionId !== r.TransactionId) {
            var MaskedPAN = r.MaskedPAN;//e.target.getAttribute("data-maskedPAN");
            var CardType = r.CardType;//e.target.getAttribute("data-cardType");
            var PaymentAccountDataToken = r.PaymentAccountDataToken; //e.target.getAttribute("data-accountDataToken");
            var TransactionId = r.TransactionId;//e.target.getAttribute("data-tid");

            var tokenBody = {
                cardNumLast4: MaskedPAN,
                cardType: CardType,
                token: PaymentAccountDataToken
            }

            this.setState({
                transactionId: TransactionId
            })

            jumperStore.addCardOnFileUpdate(id, tokenBody);
            // jumperStore.loadAllJumpers();
            // var body = JumperApi.cancelAuthorizeCaptureBody(TransactionId);
            var body = {
                TransactionId: TransactionId
            }

            var response = Api.cancelAuthorizeAndCapture(body).then(this.processUndoResponse);
            swal({
                title: "Success",
                text: "Card Added Successfully",
                icon: "success",
                dangerMode: false,
            })
            // this.props.cardsHandler();

        }
        if (window.ENV?.processorInfo.processor == 'cardConnect' && r) {
            // console.log("🚀 ~ file: ratingModal.js ~ line 647 ~ RatingModal ~ r", r)
            MaskedPAN = "xxxxxxxxxx" + r.token.slice(r.token.length - 4);//e.target.getAttribute("data-maskedPAN");
            CardType = r.accttype;//e.target.getAttribute("data-cardType");
            customerId = r.profileid //e.target.getAttribute("data-accountDataToken");
            var tokenBody = {
                cardNumLast4: MaskedPAN,
                cardType: CardType,
                customerId: customerId
            }
            // no zipcode in jumpers
            jumperStore.addCardOnFileUpdate(id, tokenBody);
        }
        else if (r.status === "success") {
            var MaskedPAN = r.data.payment_method.card.masked_card;//e.target.getAttribute("data-maskedPAN");
            var CardType = r.data.payment_method.card.card_type;//e.target.getAttribute("data-cardType");
            var cardId = r.data.payment_method.card.id;
            var customerId = r.data.id //e.target.getAttribute("data-accountDataToken");
            var TransactionId = r.data.id;//e.target.getAttribute("data-tid");
            var tokenBody = {
                cardNumLast4: MaskedPAN,
                cardType: CardType,
                cardId: cardId,
                customerId: customerId
            }

            this.setState({
                transactionId: TransactionId
            })

            jumperStore.addCardOnFileUpdate(id, tokenBody);

        }
        else if (transactionId === r.TransactionId) {
            console.log('payment Done');
            // this.props.cardsHandler();   // reload the detail page on succesfull updation
        }
        else {
            console.log('Error');
            // swal({
            //     title: "Error",
            //     text: "Something failed, please try again",
            //     icon: "error",
            //     dangerMode: true,
            // });
        }
    }
    render() {
        return (
            <Fragment>
                <div className="bluebtn" >
                    <button className="btn" type="submit"
                        onClick={this.handleCard}
                    >
                        <i className="fa fa-plus"></i>
                        card
                </button>
                </div>

                {
                    window.ENV?.processorInfo.processor == "nab" &&
                    <span id="btn_AddCard" style={{ display: 'none' }}>
                        <NabVelocity
                            amount={1}
                            terminalProfileId={window.ENV?.processorInfo.paymentKey}
                            onProcessPayment={this.handleCardResponse}
                            text="Card" />
                    </span>
                }
            </Fragment>
        )
    }
}

export default CardButton;